module.exports = __webpack_public_path__ + "img/banner.d6e88e76.jpg";